import L from 'leaflet';
/**
 * Leaflet地図表示のベースクラス
 */
export default class map_base {
    /**
     * コンストラクタ
     * @param mapElement 地図を描画するDIVのID名（省略時は上記のデフォルト名のDIVに描画）
     */
    constructor(mapElement, mapPos) {
        this.CHIMEI_SEARCH = "https://msearch.gsi.go.jp/address-search/AddressSearch";
        this.SEARCHRESULTCLICKZOOM = 15;
        this._baseLayers = this.getLayerTypes();
        this._map = this.createMapElement(mapElement, mapPos, this._baseLayers);
    }
    /**
     * leaflet地図オブジェクト
     */
    get Map() {
        return this._map;
    }
    /**
     * leaflet地図を描画します
     * @param elementName 描画するエレメント名称
     * @param mapPos 地図描画の初期位置
     * @param layersObject レイヤー情報
     */
    createMapElement(elementName, mapPos, layersObject) {
        let element = document.getElementById(elementName);
        let defaultLayer = layersObject[this.getDefaultLayer()];
        // 地図を表示
        return L.map(element, {
            center: mapPos.center,
            zoom: mapPos.zoom,
            zoomSnap: 0.5,
            minZoom: mapPos.minZoom,
            maxZoom: mapPos.maxZoom,
            zoomControl: true,
            layers: [defaultLayer]
        });
    }
    /**
     * 設定ファイルから選択可能な地図情報を取得
     */
    getLayerTypes() {
        let result = {};
        const layers = this.getLayers();
        for (let i = 0; i < layers.length; i++) {
            let name = layers[i].name;
            let targetUrl = layers[i].url;
            let copyrightUrl = layers[i].copyrightUrl;
            let layer = L.tileLayer(targetUrl, { attribution: copyrightUrl });
            result[name] = layer;
        }
        return result;
    }
    /**
     * スケールの表示
     * @param map
     */
    setScale() {
        // 縮尺の表示
        if (config.mapScaleVisible) {
            L.control.scale({ imperial: false, maxWidth: 200 }).addTo(this._map);
        }
    }
    /**
     * 地図コントロールの設定
     * @param map 地図オブジェクト
     */
    setContorl() {
        // Leafletのリンク別窓
        this._map.attributionControl.setPrefix('<a href="http://leafletjs.com" title="A JS library for interactive maps" target="_blank">Leaflet</a>');
        // コントロールレイヤ設定
        L.control.layers(this._baseLayers, undefined, { collapsed: true, position: 'topright' }).addTo(this._map);
    }
    /**
     * 設定ファイルからデフォルトの地図名称を取得します
     */
    getDefaultLayer() {
        const layers = this.getLayers();
        const defaultLayerId = this.getDefaultLeyerId();
        for (let i = 0; i < layers.length; i++) {
            let l = layers[i];
            if (l.id == defaultLayerId) {
                return l.name;
            }
        }
        return '';
    }
    /**
     *
     */
    getLayers() {
        return config.layers;
    }
    /**
     * 検索コントロールの設定
     * @param elementName
     */
    setSerchControl(elementName) {
        let self = this;
        $(elementName).submit(function () {
            // var off = $('#mapShow').offset();
            // console.log('top: ' + off.top);
            // console.log('left: ' + off.left);
            // $("#searchDialog").show();
            // $("#searchDialog").offset({ top: off.top, left: off.left });
            //alert($('#query').val());
            //var constraint = '';
            var parameter = { "q": $("#query").val() };
            $.ajax({
                type: "GET",
                url: self.CHIMEI_SEARCH,
                data: parameter,
                dataType: "json",
                timeout: config.ajaxtTimeout,
                success: L.bind(self.setChimeiRusult, self),
                error: function (xhr, textStatus, errorThrown) {
                    alert(config.ajaxErrorMessage);
                    //alert(errorThrown);
                    //alert('通信に失敗しました。');
                }
            });
            return false;
        });
    }
    setChimeiRusult(result) {
        let self = this;
        // 検索結果マーカを削除
        for (var i = 0; i < map_base.searchResultMarkers.length; i++) {
            self.Map.removeLayer(map_base.searchResultMarkers[i]);
        }
        // 検索結果ダイアログ用のHTML
        let searchResultList = '';
        // 検索実行
        var i = 0;
        $.each(result, function () {
            // 緯度経度
            let lat = result[i].geometry.coordinates[1];
            let lon = result[i].geometry.coordinates[0];
            // 地名
            let title = result[i].properties.title;
            // ポップアップテキスト
            let popupText = title + '<br><br>' + lat + ', ' + lon;
            // マーカのアイコンを定義
            let resultIcon = L.icon({
                iconUrl: 'image/search_result.png',
                iconSize: [32, 32],
                iconAnchor: [3, 22]
            });
            // 検索結果マーカを定義
            let marker = L.marker([lat, lon], {
                title: title,
                icon: resultIcon
            })
                .addTo(self.Map)
                .bindPopup(popupText);
            // .on('mouseover', function (e) {
            //     marker.openPopup();
            // });
            map_base.searchResultMarkers.push(marker);
            // 検索結果ダイアログ用のHTML
            searchResultList += '<a href="javascript:void(0);" id="aLink' + i + '">' +
                '<img src="image/search_result.png" style="width:14px;height:14px;">' + title + '</a><br>';
            i++;
        });
        $("#searchCount").text(i);
        $("#searchResultList").html(searchResultList);
        // 検索結果divをリサイズ可能にする
        /*
            $("#searchDialog").resizable({
                resize: function (event, ui) {
                    console.log('resize ui.size.height=' + ui.size.height);
                    console.log('resize ui.size.width=' + ui.size.width);
                    $('#searchResultTitle').width(ui.size.width);
                    $('#searchResultList').width(ui.size.width)
                                          .height(ui.size.height - 40 - 0)
                }
            });
        */
        $("#searchDialog").show();
        let off = $('#mapShow').offset();
        $("#searchDialog").offset({ top: off.top, left: off.left });
        i = 0;
        $.each(result, function () {
            let id = '#aLink' + i;
            $(id).click((function (lat, lon) {
                return function () {
                    self.Map.setView([lat, lon], self.SEARCHRESULTCLICKZOOM);
                };
            }(result[i].geometry.coordinates[1], result[i].geometry.coordinates[0])));
            i++;
        });
        let button = document.getElementById("text-button");
        if (button) {
            button.onclick = function () {
                // 検索結果マーカを削除
                for (var i = 0; i < map_base.searchResultMarkers.length; i++) {
                    self.Map.removeLayer(map_base.searchResultMarkers[i]);
                }
                $("#searchDialog").hide();
            };
        }
    }
}
map_base.searchResultMarkers = [];
